import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';
import { state } from './models';

export const priceOptimizerModule = {
  state,
  getters,
  actions,
  mutations
};
